import { render } from "./TablaPersonas.vue?vue&type=template&id=67864fe6&scoped=true"
import script from "./TablaPersonas.vue?vue&type=script&lang=js"
export * from "./TablaPersonas.vue?vue&type=script&lang=js"

import "./TablaPersonas.vue?vue&type=style&index=0&id=67864fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67864fe6"]])

export default __exports__